import React, { useEffect, useRef, useState } from 'react'
import CountUp from 'react-countup'

const Octogono = props => {
    const [isVisible, setIsVisible] = useState(false)
    const [key, setKey] = useState(0)
    const ref = useRef(null)

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true)
                    setKey(prev => prev + 1) // fuerza remount para reiniciar el conteo
                } else {
                    setIsVisible(false)
                }
            },
            { threshold: 0.3 } // ajustá el % de visibilidad que dispara el conteo
        )

        if (ref.current) observer.observe(ref.current)

        return () => {
            if (ref.current) observer.unobserve(ref.current)
        }
    }, [])

    return (
        <div className="text-center" ref={ref}>
            <div className="octogon-container d-flex justify-content-center align-items-center text-center">
                {isVisible && (
                    <CountUp
                        key={key}
                        start={0}
                        end={props.number}
                        duration={4}
                        prefix="+"
                        delay={0}
                        decimals={0}
                    >
                        {({ countUpRef }) => (
                            <div className="mr-1">
                                <span
                                    className="number-counter gold"
                                    ref={countUpRef}
                                />
                            </div>
                        )}
                    </CountUp>
                )}
            </div>

            <p
                style={{ fontSize: "23px" }}
                className="greenblue text-large bold px-2"
            >
                {props.title}
            </p>
        </div>
    )
}

export default Octogono